export const AYURVEDA_ENCYCLOPEDIA_DATA = [
    {
        section: 1, name: "Fundamentals", chapters: [
            { ind: 1, name: "Overview", subChapters: {} },
            { ind: 2, name: "The Human Universe", subChapters: {} }
        ]
    },
    {
        section: 2, name: "Analysis", chapters: [
            { ind: 1, name: "Analyzing Constitutions and Illness", subChapters: {} }
        ]
    },
    {
        section: 3, name: "Therapeutics", chapters: [
            { ind: 1, name: "Herbology", subChapters: {} },
            { ind: 2, name: "Glossary", subChapters: {} },
            { ind: 3, name: "Nutrition", subChapters: {} },
            { ind: 4, name: "Pancha Karma", subChapters: {} },
            { ind: 5, name: "Aromatherapy", subChapters: {} },
            { ind: 6, name: "Hatha Yoga and Pranayama", subChapters: {} },
            { ind: 7, name: "Sound Therapy - Mantras, Chakras, and music", subChapters: {} },
            { ind: 8, name: "Color and Gems", subChapters: {} },
            { ind: 9, name: "External Influences - Lifestyle, Season", subChapters: {} },
            { ind: 10, name: "Psychology, Ethics and Spiritual Counselling", subChapters: {} }
        ]
    },
    {
        section: 4, name: "Specific Illness and Diseases", chapters: [
            {
                ind: 1, name: "Circulatory System", subChapters: {
                    1: "Bleeding",
                    2: "Anemia",
                    3: "Heart",
                    4: "Blood Pressure",
                    5: "Arteriosclerosis",
                    6: "Paraplegia"
                }
            },
            {
                ind: 2, name: "Digestive System", subChapters: {
                    1: "Anorexia",
                    2: "Vomiting",
                    3: "Diarrhea/Dysentery",
                    4: "Digestion",
                    5: "Abdomen",
                    6: "Jaundice",
                    7: "Gall Stones",
                    8: "Dyspepsia",
                    9: "Indigestion",
                    10: "Gastroenteritis",
                    11: "Colic",
                    12: "Hyperacidity",
                    13: "Gastritis",
                    14: "Malabsorption",
                    15: "Food Allergies & Parasites",
                    16: "Constipation",
                    17: "Hemorrhoids",
                    18: "Obesity",
                    19: "Candida",
                    20: "Ulcers",
                    21: "Toxin(Ama)"
                }
            },
            {
                ind: 3, name: "Infection and Wounds", subChapters: {
                    1: "Fever",
                    2: "Abscess",
                    3: "Sinus",
                    4: "Wounds",
                    5: "Inflammatory Ulcers",
                    6: "Fractures/Dislocations"
                }
            },
            {
                ind: 4, name: "Respiratory System", subChapters: {
                    1: "Cough",
                    2: "Breathing",
                    3: "Hiccup",
                    4: "TB",
                    5: "Cold"
                }
            },
            {
                ind: 5, name: "Urinary System", subChapters: {
                    1: "Urine",
                    2: "Prostate",
                    3: "Diabetes"
                }
            },
            {
                ind: 6, name: "Ear, Nose, Throat, Mouth, and Eyes", subChapters: {
                    1: "Ears",
                    2: "Nose",
                    3: "Catarrh",
                    4: "Hoarse Throat",
                    5: "Eyes",
                    6: "Mouth"
                }
            },
            {
                ind: 7, name: "Nervous System", subChapters: {
                    1: "Convulsions",
                    2: "Sciatica",
                    3: "Insanity",
                    4: "Epilepsy",
                    5: "Addictions",
                    6: "Alcohal Recovery",
                    7: "Fainting",
                    8: "Coma",
                    9: "Wasting",
                    10: "Multiple Sclerosis",
                    11: "Parkinsons",
                    12: "Alzheimers"
                }
            },
            {
                ind: 8, name: "Skin", subChapters: {
                    1: "Warts",
                    2: "Skin",
                    3: "Leukoderma",
                    4: "Herpes Zoster"
                }
            },
            {
                ind: 9, name: "Neoplasm/Abnormal Growths", subChapters: {
                    1: "Scrotum",
                    2: "Fistula",
                    3: "Elephantiasis",
                    4: "Hernia",
                    5: "Tumors",
                    6: "Cancer"
                }
            },
            {
                ind: 10, name: "Reproductive System", subChapters: {
                    1: "Females",
                    2: "Childbirth",
                    3: "Planets and Newborns",
                    4: "Males",
                    5: "Venereal Disease"
                }
            },
            {
                ind: 11, name: "Immune System", subChapters: {
                    1: "HIV/AIDS",
                    2: "Epstein Barr",
                    3: "Fibromyalgia"
                }
            },
            {
                ind: 12, name: "Metabolic System", subChapters: {
                    1: "Edema",
                    2: "Meningitis",
                    3: "Quinsy",
                    4: "Tonsillitis",
                    5: "Abscesses",
                    6: "Goiter",
                    7: "Hyperthyroidism",
                    8: "Benign Tumors",
                    9: "Gout",
                    10: "Thirst"
                }
            },
            {
                ind: 13, name: "Miscellaneous", subChapters: {
                    1: "Three Vital Organs-Heart, Head, Bladder",
                    2: "Headaches,Migraines",
                    3: "Arthritis,Rheumatism",
                    4: "Dangerous Spriritual Practices",
                    5: "Herbs for Tissue and Organs",
                    6: "Gland Definitions",
                    7: "Organs and Doshas",
                    8: "When to take Herbs",
                    9: "Herbal Recipes",
                    10: "Mutually Incompatible Foods",
                    11: "Herb Preparation and Use",
                    12: "Herb Mixing",
                    13: "Ayurvedic Acupuncture"
                }
            },
            {
                ind: 14, name: "Outer Healing", subChapters: {
                    1: "Beauty Care",
                    2: "Jyotish - Vedic Astrology",
                    3: "Vastu Shastra",
                    4: "Feng Shui",
                    5: "Scientific Research",
                    6: "Ecological-caused disorders"
                }
            }
        ]
    }
]